import React from 'react';
import { SchematicShell } from './SchematicPrimitives';

const IN = 0.0254;

const TAPER = 0.85;
const RIM_H = 0.375 * IN;
const RIM_OVERHANG = 0.1 * IN;

export function DormWastebasketSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    const rimW = depth + RIM_OVERHANG * 2;
    const botD = depth * TAPER;
    const offsetTop = (rimW - depth) / 2;
    const offsetBot = (rimW - botD) / 2;

    return (
      <SchematicShell
        width={rimW}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
        drawFrame={false}
      >
        <g
          transform={
            view === 'right' ? `scale(-1, 1) translate(${-rimW}, 0)` : undefined
          }
        >
          {/* Rim top edge */}
          <line
            x1={0}
            y1={0}
            x2={rimW}
            y2={0}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Rim bottom / body top — inset from rim */}
          <line
            x1={offsetTop}
            y1={RIM_H}
            x2={rimW - offsetTop}
            y2={RIM_H}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Left rim vertical */}
          <line
            x1={0}
            y1={0}
            x2={0}
            y2={RIM_H}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Right rim vertical */}
          <line
            x1={rimW}
            y1={0}
            x2={rimW}
            y2={RIM_H}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Left rim step down */}
          <line
            x1={0}
            y1={RIM_H}
            x2={offsetTop}
            y2={RIM_H}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Right rim step down */}
          <line
            x1={rimW - offsetTop}
            y1={RIM_H}
            x2={rimW}
            y2={RIM_H}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Left tapered side */}
          <line
            x1={offsetTop}
            y1={RIM_H}
            x2={offsetBot}
            y2={height}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Right tapered side */}
          <line
            x1={rimW - offsetTop}
            y1={RIM_H}
            x2={rimW - offsetBot}
            y2={height}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
          {/* Bottom edge */}
          <line
            x1={offsetBot}
            y1={height}
            x2={rimW - offsetBot}
            y2={height}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            vectorEffect="non-scaling-stroke"
          />
        </g>
      </SchematicShell>
    );
  }

  // Front view
  const rimW = width + RIM_OVERHANG * 2;
  const botW = width * TAPER;
  const offsetTop = (rimW - width) / 2;
  const offsetBot = (rimW - botW) / 2;

  return (
    <SchematicShell
      width={rimW}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      drawFrame={false}
    >
      {/* Rim top edge */}
      <line
        x1={0}
        y1={0}
        x2={rimW}
        y2={0}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Rim bottom / body top — inset from rim */}
      <line
        x1={offsetTop}
        y1={RIM_H}
        x2={rimW - offsetTop}
        y2={RIM_H}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Left rim vertical */}
      <line
        x1={0}
        y1={0}
        x2={0}
        y2={RIM_H}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Right rim vertical */}
      <line
        x1={rimW}
        y1={0}
        x2={rimW}
        y2={RIM_H}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Left rim step down */}
      <line
        x1={0}
        y1={RIM_H}
        x2={offsetTop}
        y2={RIM_H}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Right rim step down */}
      <line
        x1={rimW - offsetTop}
        y1={RIM_H}
        x2={rimW}
        y2={RIM_H}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Left tapered side */}
      <line
        x1={offsetTop}
        y1={RIM_H}
        x2={offsetBot}
        y2={height}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Right tapered side */}
      <line
        x1={rimW - offsetTop}
        y1={RIM_H}
        x2={rimW - offsetBot}
        y2={height}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Bottom edge */}
      <line
        x1={offsetBot}
        y1={height}
        x2={rimW - offsetBot}
        y2={height}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Subtle vertical rib line (center) */}
      <line
        x1={rimW / 2}
        y1={RIM_H + (height - RIM_H) * 0.1}
        x2={rimW / 2}
        y2={height * 0.92}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeOpacity={0.4}
        vectorEffect="non-scaling-stroke"
      />
    </SchematicShell>
  );
}

DormWastebasketSchematic.supportsSideViews = true;
